import type { DynamicClient } from '../../../client/types';
import { assertDefined } from '../../../utils/assertDefined';
import { p256Sign } from '../../../utils/p256Sign';
import { getSessionKeys } from '../getSessionKeys';

type GenerateNonceSignatureParams = {
  nonce: string;
};

export const generateNonceSignature = async (
  { nonce }: GenerateNonceSignatureParams,
  client: DynamicClient
) => {
  const sessionKeys = getSessionKeys(client);
  assertDefined(sessionKeys, 'Session keys not found');

  const { privateKeyJwk } = sessionKeys;

  const signature = await p256Sign({
    message: nonce,
    privateKeyJwk,
  });

  return { signature };
};
